import { render, staticRenderFns } from "./addChangeBatch.vue?vue&type=template&id=76f44d8a&scoped=true"
import script from "./addChangeBatch.vue?vue&type=script&lang=js"
export * from "./addChangeBatch.vue?vue&type=script&lang=js"
import style0 from "./addChangeBatch.vue?vue&type=style&index=0&id=76f44d8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f44d8a",
  null
  
)

export default component.exports